export default __webpack_public_path__ + "static/media/IMG_2349.556ee941.jpg";